import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import { cn } from '@/lib/utils'

interface SectionHeadingProps {
  title: string
  subtitle?: React.ReactNode
  subtitleClassName?: string
  href?: string
  linkLabel?: string
}

export function SectionHeading({
  title,
  subtitle,
  subtitleClassName,
  href,
  linkLabel = 'View all',
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
      <div className={cn(subtitleClassName?.includes('max-w-none') && 'w-full min-w-0')}>
        <h2 className="font-display text-3xl md:text-4xl font-bold gold-gradient-text">
          {title}
        </h2>
        {subtitle && (
          <p
            className={cn(
              'mt-2 text-sm text-zinc-500 max-w-xl',
              subtitleClassName
            )}
          >
            {subtitle}
          </p>
        )}
      </div>
      {href && (
        <Link
          to={href}
          className="inline-flex items-center gap-1 text-sm text-gold-400 hover:text-gold-300"
        >
          {linkLabel} <ArrowRight className="h-4 w-4" />
        </Link>
      )}
    </div>
  )
}
